import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import ImageHandler from 'components/explore/lists/ImageHandler.js';

const TextureLoader = ({textureLoader}) => { 
    let [imageHash, setImageHash] = useState(textureLoader.imageHash);

    useEffect(() => {
        if (imageHash) {
            textureLoader.loadImage(imageHash);
        }
    }, [imageHash]);

    return (
        <div className="texture-loader">
          <ImageHandler placeholder="Drag new image here" imageHash={imageHash} setImageHash={setImageHash}/>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextureLoader);
